import { Tooltip } from 'antd'
import PaintWithUpload from '../lab/PaintWithUpload'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { MutableRefObject } from 'react'

export const MaskImageComp: React.FC = () => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-1">
        <div className="text-neutral-500 text-xs">
          * 上传图片{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="对上传图片涂抹区域较大时，图像的生成效果会更好，过小涂抹区域可能会无效，小区域涂抹画面描述适合输入“修复”进行图像自动擦除修复"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
      </div>

      <PaintWithUpload />
    </div>
  )
}
